// extracted by mini-css-extract-plugin
export default {"rowStyle":"pago_rowStyle__vklIq","collapseStyle":"pago_collapseStyle__uOcTE"};